import {
  ADD_TOKEN,
  ADD_ID,
  ADD_CURR,
  ADD_LANG,
  ADD_UNIT,
  ADD_PKUIDLIST,
  ADD_IDARTICLE,
  ADD_GGTOKEN,
  ADD_EMAIL,
  ADD_PKUIDSUB,
  ADD_STRIPETOKEN,
  ADD_NAME,
  ADD_MODAL,
  ADD_USERNAME,
  ADD_REGISTER,
  ADD_LOGIN,
  ADD_RENAME,
  ADD_RESET,
  ADD_STRIPE_POPUP,
  ADD_CONTACT_INFO,
  ADD_SELECTED_USER_TYPE,
  SET_ENV,
} from '../constants/AppConstants';


export default function AppReducer(state = {}, action) {
  switch (action.type) {
    case ADD_TOKEN:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_STRIPE_POPUP:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_RESET:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_REGISTER:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_LOGIN:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_RENAME:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_ID:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_CURR:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_LANG:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_UNIT:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_PKUIDLIST:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_IDARTICLE:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_GGTOKEN:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_EMAIL:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_PKUIDSUB:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_STRIPETOKEN:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_NAME:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_USERNAME:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_CONTACT_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_SELECTED_USER_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ENV:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducers.js